import React from "react";
import SectionCommonTable from "../../components/SectionCommonTable";
import TxnHistoryTable from "./table/eBTT.TxnHistoryTable";

const TxnHistoryPage = () => {
  return (
    <SectionCommonTable
      wrapperClassName="ebtt_txnhistory_table"
      cardStyle={{ backgroundColor: "#fff" }}
      sectionTableTitle="Mono Txn History"
      countContainer="My mono Balance : 248.00 mono"
      table={<TxnHistoryTable />}
      calculateContainer={true}
      calculateCredit="Total Credit : 0.00"
      calculateDebit="Total Debit : 0.00"
    />
  );
};

export default TxnHistoryPage;
